<app-navbar
	(login)="login()"
	(logout)="logout()"
	[loginDisplay]="loginDisplay"
/>

<main>
	<router-outlet />
	<app-error-dialog />
</main>
